module.exports = __webpack_public_path__ + "img/sejong_gallery2.5bdba99c.jpg";